import React, { Fragment, Component } from 'react';
import { loadPosts } from '../../actions/posts'
import { connect } from 'react-redux'
import {Icon} from 'antd'
import PostBox from '../../PostBox'
import PostForm from '../../PostForm'
import withSizes from 'react-sizes'
import refresh from '../../images/refresh.png'
// import home from '../../images/home.png'
import history from '../../history'
import Intro from '../../Intro'
import './Home.css'
import WXConfig from "../../WXConfig";

class Home extends Component {

  componentDidMount(){
    if(!this.props.posts || this.props.posts.length === 0){
      this.props.loadPosts()
    }
  }

  shuffle(a) {
    var j, x, i;
    for (i = a.length - 1; i > 0; i--) {
      j = Math.floor(Math.random() * (i + 1));
      x = a[i];
      a[i] = a[j];
      a[j] = x;
    }
    return a;
  }


  renderMessages(){
    let {match:{params:{location}}, posts, width, height, randomXs, randomYs} = this.props
    let first = posts[0]
    posts = this.shuffle(posts.slice(1,))
    if(posts.length>50){
     posts = posts.slice(0, 50)
    }
    let selectPosts = posts
    if(first){
      selectPosts.unshift(first)
    }
    return selectPosts.reverse().map((post,index)=>{
      let ratio = 0.75
      if(index >= 49){
        ratio = 0.2
      }
      let randomX = post.position && post.position.x || randomXs[post._id] || 0
      let randomY = post.position && post.position.y || randomYs[post._id] || 0
      let x = 0.5*width + ratio*width*(0.5 - randomX)
      const y = 0.5*height + ratio*height*(0.5 - randomY)
      return <PostBox
          x={x}
          y={y}
          randomX={randomX}
          randomY={randomY}
          post={post}
          key={index}
          totalWidth={width}
          totalHeight={height}
        />
    })
  }

  render() {
    const {loadingPosts, loadingPostsError, my} = this.props
    const self = this
    return <div
      className="home-posts-container"
    >
      {
        loadingPostsError && <span className={'center danger'}>
          {loadingPostsError}
        </span>
      }
      {
        (!loadingPostsError && loadingPosts) && <span className={'center'}>
          <Icon type="loading" className={'loading-icon center'} />
          <span className={'text'}>载入中...</span>
        </span>
      }
      {
        (!loadingPostsError && !loadingPosts) && <Fragment>
          <div className="home-posts-container">
            <div
              className={"home-posts-back"}
              style={{
                backgroundImage: `url(${refresh})`
              }}
              onClick = {()=> {
                self.props.loadPosts()
              }}
            />
            {my && my.weixin &&
            <div
              className={"home-posts-header"}
              style={{
                backgroundImage: `url(${my.weixin.headimgurl})`
              }}
              onClick={()=> {
                history.push('/users/'+my._id)
              }}
            />
            }
            {this.renderMessages()}
          </div>
          <PostForm />
          <Intro />
          <WXConfig
            title={"「你好，朋友」"}
            desc={"有一种说法「艺术是提出问题，而非给出答案」，「你好，朋友」邀请你在这里直接提出和讨论问题。"}
            link={window.location.href}
          />
        </Fragment>
      }
    </div>
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    posts: state.posts.posts,
    my: state.user.my,
    randomXs: state.posts.randomXs,
    randomYs: state.posts.randomYs,
    loadingPosts: state.posts.loadingPosts,
    loadingPostsError: state.posts.loadingPostsError
  }
}

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    loadPosts: ()=>dispatch(loadPosts()),
  }
}

const mapSizesToProps = ({ width, height }) => {
  return {width, height}
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withSizes(mapSizesToProps)(Home))




// WEBPACK FOOTER //
// ./src/routes/home/Home.js